/* @generated */

// ../src/modal/modal.tsx
import classNames7 from "classnames";
import * as React7 from "react";
import ReactModal from "react-modal";
import "focus-visible";
import { MODAL_BASE_INDEX, LayerContext } from "@dropbox/dig-components/layer";
import { useTheme } from "@dropbox/dig-foundations";
import { IconButton } from "@dropbox/dig-components/buttons";
import { UIIcon } from "@dropbox/dig-icons";
import { CloseLine } from "@dropbox/dig-icons/assets";

// ../src/modal/content.tsx
import * as React from "react";
import classNames from "classnames";

// ../src/modal/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var modalBodyRecipe = _7a468({ defaultClassName: "dig-1w9fcz97_21-1-1", variantClassNames: { hasVerticalSpacing: { true: "dig-1w9fcz98_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var modalCloseButtonStyle = "dig-1w9fcz9h_21-1-1";
var modalContentStyle = "dig-1w9fcz9a_21-1-1";
var modalFooterRecipe = _7a468({ defaultClassName: "dig-1w9fcz9d_21-1-1", variantClassNames: { preferComposition: { true: "dig-1w9fcz9e_21-1-1", false: "dig-1w9fcz9f_21-1-1" }, hasTopBorder: { true: "dig-1w9fcz9g_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var modalFullWidthStyle = "dig-1w9fcz99_21-1-1";
var modalHeaderRecipe = _7a468({ defaultClassName: "dig-1w9fcz95_21-1-1", variantClassNames: { marginTitleStandard: { true: "dig-1w9fcz96_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var modalHtmlStyle = "dig-1w9fcz9i_21-1-1";
var modalOverlayStyle = "dig-1w9fcz9b_21-1-1";
var modalRecipe = _7a468({ defaultClassName: "dig-1w9fcz92_21-1-1", variantClassNames: { isCentered: { true: "dig-1w9fcz93_21-1-1" }, fullScreen: { true: "dig-1w9fcz94_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var modalTitleStyle = "dig-1w9fcz9c_21-1-1";

// ../src/modal/content.tsx
var Content = ({ children, className, ...rest }) => /* @__PURE__ */ React.createElement("div", { className: classNames("dig-Modal-content", modalContentStyle, className), ...rest }, children);

// ../src/modal/header.tsx
import * as React2 from "react";
import classNames2 from "classnames";
var Header = ({
  hasBottomSpacing = "title-small",
  children,
  className = "",
  ...rest
}) => {
  const cls = classNames2(
    "dig-Modal-header",
    modalHeaderRecipe({ marginTitleStandard: hasBottomSpacing === "title-standard" }),
    {
      "dig-Modal-header--margin-title-standard": hasBottomSpacing === "title-standard"
    },
    className
  );
  return /* @__PURE__ */ React2.createElement("div", { className: cls, ...rest }, children);
};
Header.displayName = "Header";

// ../src/modal/body.tsx
import * as React3 from "react";
import classNames3 from "classnames";
var Body = React3.forwardRef(
  ({ children, className = "", hasVerticalSpacing = false, ...rest }, ref) => {
    const cls = classNames3("dig-Modal-body", modalBodyRecipe({ hasVerticalSpacing }), className, {
      "dig-Modal-body--hasVerticalSpacing": hasVerticalSpacing
    });
    return /* @__PURE__ */ React3.createElement("div", { ref, className: cls, ...rest }, children);
  }
);
Body.displayName = "Body";

// ../src/modal/footer.tsx
import * as React4 from "react";
import classNames4 from "classnames";
var Footer = ({
  hasTopBorder = false,
  children,
  className = "",
  preferComposition = false,
  ...rest
}) => {
  const cls = classNames4(
    {
      "dig-Modal-footer": !preferComposition,
      "dig-Modal-prefer-composition-footer": preferComposition,
      "dig-Modal-footer--hasTopBorder": hasTopBorder
    },
    modalFooterRecipe({ preferComposition, hasTopBorder }),
    className
  );
  return /* @__PURE__ */ React4.createElement("div", { className: cls, ...rest }, children);
};
Footer.displayName = "Footer";

// ../src/modal/title.tsx
import * as React5 from "react";
import classNames5 from "classnames";
import {
  Title as TypographyTitle
} from "@dropbox/dig-components/typography";
var Title = ({ children, className = "", ...rest }) => {
  const cls = classNames5("dig-Modal-title", modalTitleStyle, className);
  return /* @__PURE__ */ React5.createElement(TypographyTitle, { className: cls, ...rest }, children);
};
Title.displayName = "Title";

// ../src/modal/full_bleed.tsx
import * as React6 from "react";
import classNames6 from "classnames";
var FullBleed = ({
  children,
  className,
  ...rest
}) => {
  const cls = classNames6("dig-Modal-full-width", modalFullWidthStyle, className);
  return /* @__PURE__ */ React6.createElement("div", { className: cls, ...rest }, children);
};

// ../src/modal/modal.tsx
var getWidthPx = (width) => {
  switch (width) {
    case "small":
      return 450;
    case "standard":
      return 600;
    case "large":
      return 700;
  }
  return width;
};
var Modal = React7.forwardRef(
  ({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedby,
    children,
    className,
    fullScreen = false,
    isCentered = false,
    withCloseButton,
    width = "standard",
    open = false,
    shouldCloseOnOverlayClick = true,
    shouldFocusAfterRender = true,
    onRequestClose,
    onAfterOpen,
    onAfterClose,
    overlayClassName,
    modalBaseIndex = MODAL_BASE_INDEX,
    parentSelector,
    hasAutoFocusClose = false,
    closeButtonProps,
    overlayStyles,
    contentStyles,
    contentOverflow = "visible",
    data,
    ...rest
  }, ref) => {
    const contentRef = React7.useRef();
    const { getThemeProps } = useTheme();
    const cls = classNames7(
      "dig-Modal",
      modalRecipe({ isCentered, fullScreen }),
      {
        "dig-Modal--isCentered": isCentered,
        "dig-Modal--fullScreen": fullScreen
      },
      className
    );
    const attachContentRef = React7.useCallback((instance) => {
      contentRef.current = instance;
    }, []);
    const onClickClose = onRequestClose;
    const focus = React7.useCallback(() => {
      if (contentRef && contentRef.current) {
        contentRef.current.focus();
      }
    }, [contentRef]);
    React7.useImperativeHandle(ref, () => ({ focus }), [focus]);
    const ariaProp = React7.useMemo(() => {
      if (ariaLabelledby === void 0) {
        return void 0;
      }
      return {
        labelledby: ariaLabelledby,
        describedby: ariaDescribedby
      };
    }, [ariaLabelledby, ariaDescribedby]);
    return /* @__PURE__ */ React7.createElement(
      ReactModal,
      {
        ...rest,
        data,
        testId: rest.testId || rest["data-testid"],
        aria: ariaProp,
        contentLabel: ariaLabel,
        contentRef: attachContentRef,
        isOpen: open,
        shouldCloseOnOverlayClick,
        shouldFocusAfterRender,
        onRequestClose,
        onAfterOpen,
        onAfterClose,
        className: cls,
        bodyOpenClassName: classNames7("dig-Modal-body--open", modalHtmlStyle),
        htmlOpenClassName: classNames7("dig-Modal-html--open", modalHtmlStyle),
        overlayClassName: classNames7(
          "dig-Modal-overlay",
          modalOverlayStyle,
          overlayClassName,
          // We add the theme class names to the root-most container of `Modal`
          getThemeProps().className
        ),
        parentSelector,
        closeTimeoutMS: 200,
        style: {
          overlay: {
            ...overlayStyles,
            // `react-modal` by default portals into the `document.body` and isn't connected to
            // our elevation system. To address this, we need to apply a z-index to the
            // internal overlay rendered by `react-modal` so if there's any elevated
            // components (Menu, Tooltips, etc.) that is rendered within this sub-layer, it will
            // be properly laid at a higher z-index.
            zIndex: modalBaseIndex
          },
          content: {
            ...contentStyles,
            width: fullScreen ? "100%" : getWidthPx(width)
          }
        }
      },
      /* @__PURE__ */ React7.createElement(LayerContext.Provider, { value: { zIndex: modalBaseIndex } }, /* @__PURE__ */ React7.createElement(Content, { style: { overflow: contentOverflow === "hidden" ? "hidden" : void 0 } }, children), !!withCloseButton && /* @__PURE__ */ React7.createElement(
        IconButton,
        {
          variant: "transparent",
          "aria-label": withCloseButton,
          "data-testid": "digModalCloseButton",
          autoFocus: hasAutoFocusClose,
          ...closeButtonProps,
          className: classNames7(
            "dig-Modal-close-btn",
            modalCloseButtonStyle,
            closeButtonProps == null ? void 0 : closeButtonProps.className
          ),
          onClick: (e) => {
            var _a;
            onClickClose == null ? void 0 : onClickClose(e);
            (_a = closeButtonProps == null ? void 0 : closeButtonProps.onClick) == null ? void 0 : _a.call(closeButtonProps, e);
          }
        },
        /* @__PURE__ */ React7.createElement(UIIcon, { src: CloseLine })
      ))
    );
  }
  // Type assertion to enable adding subcomponents as static props below
  // There doesn't seem to be a way to avoid this with current forwardRef typings
  // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757
);
Modal.Content = Content;
Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;
Modal.Title = Title;
Modal.FullBleed = FullBleed;
Modal.displayName = "Modal";
var setAppElement = (appElement) => {
  ReactModal.setAppElement(appElement);
};
Modal.setAppElement = setAppElement;
export {
  Modal
};
